module.exports = __webpack_public_path__ + "img/sectionnelle.3f86916.svg";